export default __webpack_public_path__ + "static/media/collapse.9051dddd.svg";